import React from 'react';

import type { SimpleIconInterface } from './icon-utils';
import { IconColors, SimpleIcon } from './icon-utils';

export function FavoriteDocumentIcon({
  className,
  dataCy,
  fill = IconColors.DarkGrey,
  height = 16,
  style,
  width = 16,
}: SimpleIconInterface): JSX.Element {
  return (
    <SimpleIcon
      className={className}
      dataCy={dataCy}
      fill="none"
      height={height}
      style={style}
      viewBoxDimensions="0 0 16 16"
      width={width}
    >
      <path
        d="M14.4735 3.80667L10.8602 0.193333C10.736 0.0701706 10.5684 0.000736414 10.3935 0H2.66683C2.31321 0 1.97407 0.140476 1.72402 0.390524C1.47397 0.640573 1.3335 0.979711 1.3335 1.33333V14.6667C1.3335 15.0203 1.47397 15.3594 1.72402 15.6095C1.97407 15.8595 2.31321 16 2.66683 16H13.3335C13.6871 16 14.0263 15.8595 14.2763 15.6095C14.5264 15.3594 14.6668 15.0203 14.6668 14.6667V4.27333C14.6661 4.09844 14.5967 3.93084 14.4735 3.80667ZM13.3335 14.3333C13.3335 14.4217 13.2984 14.5065 13.2359 14.569C13.1734 14.6315 13.0886 14.6667 13.0002 14.6667H3.00016C2.91176 14.6667 2.82697 14.6315 2.76446 14.569C2.70195 14.5065 2.66683 14.4217 2.66683 14.3333V1.66667C2.66683 1.57826 2.70195 1.49348 2.76446 1.43096C2.82697 1.36845 2.91176 1.33333 3.00016 1.33333H10.0002C10.0449 1.33268 10.0893 1.34123 10.1305 1.35843C10.1718 1.37563 10.2091 1.40112 10.2402 1.43333L13.2602 4.45333C13.3092 4.51348 13.3352 4.5891 13.3335 4.66667V14.3333Z"
        fill={fill}
      />
      <path
        d="M9.59371 6.35334C9.33024 6.31003 9.06023 6.3304 8.80624 6.41274C8.55225 6.49508 8.32165 6.63701 8.13371 6.82667C8.11633 6.84441 8.09558 6.8585 8.07269 6.86812C8.04979 6.87774 8.02521 6.8827 8.00037 6.8827C7.97554 6.8827 7.95095 6.87774 7.92806 6.86812C7.90516 6.8585 7.88442 6.84441 7.86704 6.82667C7.54851 6.53465 7.1297 6.37661 6.69766 6.38538C6.26563 6.39415 5.85358 6.56906 5.54716 6.87376C5.24074 7.17846 5.06352 7.58952 5.05232 8.0215C5.04113 8.45348 5.19682 8.87317 5.48704 9.19334L7.76037 11.5667C7.8241 11.6302 7.9104 11.6658 8.00037 11.6658C8.09034 11.6658 8.17664 11.6302 8.24037 11.5667L10.507 9.2C10.7258 8.98168 10.8801 8.70725 10.9529 8.40691C11.0257 8.10657 11.0143 7.79196 10.9199 7.49768C10.8255 7.20341 10.6517 6.94088 10.4178 6.73898C10.1838 6.53709 9.89863 6.40364 9.59371 6.35334Z"
        fill={fill}
      />
    </SimpleIcon>
  );
}
